import { AppCheckboxGroup } from 'shared/UI/UIKit/Checkbox';
import { AppDropdown } from 'shared/UI/UIKit/Dropdown';
import { AppIconButton } from 'shared/UI/UIKit/Button';
import { AppSettingsIcon } from 'shared/UI/UIKit/icons/Settings';
import type { ColumnType } from 'antd/lib/table';
import styles from './TableColumnsFilter.module.scss';
import { useTableColumnsFilter } from './use-table-columns-filter';

interface TableColumnsFilterProps {
  columns: ColumnType<any>[];
  onColumnsChange: (columns: ColumnType<any>[]) => void;
  hiddenByDefaultKeys?: string[];
}

export const TableColumnsFilter = ({
  columns,
  onColumnsChange,
  hiddenByDefaultKeys,
}: TableColumnsFilterProps) => {
  const {
    state: { options, visibleKeys },
    methods: { handleChange },
  } = useTableColumnsFilter(columns, onColumnsChange, hiddenByDefaultKeys);

  const overlay = (
    <div className={styles.overlay}>
      <AppCheckboxGroup
        options={options}
        value={visibleKeys}
        onChange={handleChange}
        direction="vertical"
      />
    </div>
  );

  return (
    <AppDropdown overlay={overlay}>
      <AppIconButton type="primary">
        <AppSettingsIcon className={styles.icon} />
      </AppIconButton>
    </AppDropdown>
  );
};
